import React from 'react';
import styles from './ShareButton.module.css';
import Button from "@mui/material/Button";
import ShareIcon from '@mui/icons-material/Share';

const ShareButton = () => {
    const handleShare = async () => {
        const shareData = {
            title: "Enzo's Toolkit - 로또 번호 생성기",
            text: '제가 생성한 이번 주 로또 행운 번호예요! ',
            url: 'https://www.enzo2.life/lotto',
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (error) {
                console.error('Error sharing:', error);
            }
        } else {
            try {
                await navigator.clipboard.writeText(shareData.url);
                alert('페이지 주소가 복사되었습니다!');
            } catch (error) {
                console.error('Error copying to clipboard:', error);
            }
        }
    };

    return (
        <Button
            variant="contained"
            onClick={handleShare}
            className={styles.shareButton}
            startIcon={<ShareIcon />}
        >
            공유하기
        </Button>
    );
};

export default ShareButton;
